import { type PropsWithChildren } from 'react';

import { Pan } from './Pan.js';
import { Zoom } from './Zoom.js';
import { ZoomX } from './ZoomX.js';

/**
 * ChartInteractions slot component.
 */
const ChartInteractionsRoot = (props: PropsWithChildren) => null;

ChartInteractionsRoot['displayName'] = 'ChartInteractions';

/**
 * Zoom interactions slot component
 * @public
 */
export const ChartInteractions = Object.assign(ChartInteractionsRoot, {
  Zoom,
  ZoomX,
  Pan,
});
